import script from "./PlanosPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanosPage.vue?vue&type=script&setup=true&lang=js"

import "./PlanosPage.vue?vue&type=style&index=0&id=1397e694&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1397e694"]])

export default __exports__